module.exports = __webpack_public_path__ + "img/download(1).89d6800b.png";